import { DeviceMediaRequest, getApiUrl } from "@app/shared";
import { useSignalr } from "@known-as-bmf/react-signalr";
import { useEffect, useCallback } from "react";
import { Subscription } from "rxjs";

// Keep in sync with MediaRequestHub.WatchMediaRequests / StopWatchingMediaRequests in CoreApi
const WATCH_REQUESTS_COMMAND = 'WatchMediaRequests';
const STOP_WATCHING_REQUESTS_COMMAND = 'StopWatchingMediaRequests';
// Keep in sync with IMediaRequestStatusClient.ReceiveMediaRequests in CoreApi
const REQUESTS_UPDATE_EVENT = 'ReceiveMediaRequests';

export function useMediaRequestsHub(deviceId: string | undefined, onRequestsReceived: (t: DeviceMediaRequest[]) => void, unsubscribe?: boolean) {
    const { send, on } = useSignalr(getApiUrl(`/hubs/mediarequests`));

    const handleRequestsReceived = useCallback((requests: DeviceMediaRequest[]) => {
        onRequestsReceived(requests.map(t => new DeviceMediaRequest(t as any)))
    }, [onRequestsReceived]);


    useEffect(() => {
        if (!deviceId) return;
        send(WATCH_REQUESTS_COMMAND, deviceId);
        return () => {
            send(STOP_WATCHING_REQUESTS_COMMAND, deviceId);
        };
    }, [deviceId, send]);

    useEffect(() => {
        let onTargetsReceived: Subscription | undefined;

        if (!unsubscribe) {
            onTargetsReceived = on<DeviceMediaRequest[]>(REQUESTS_UPDATE_EVENT).subscribe(handleRequestsReceived);
        }

        return () => {
            onTargetsReceived?.unsubscribe();
        }
    }, [on, unsubscribe, handleRequestsReceived]);

}